import React from 'react';

// Brand logo mark — exact uploaded final logo symbol (transparent PNG)
export const LogoMark = ({ className = '', title = 'In Buona Compagnia' }) => (
  <img src="/logo-symbol.png" alt={title} className={`${className} object-contain`} />
);

// Abstract terracotta line-art leaf/branch ornament
export const OrnamentLeaf = ({ className = '' }) => (
  <svg viewBox="0 0 200 120" className={className} fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round">
    <path d="M10 110 C60 40 120 30 190 15" />
    <path d="M60 78 C70 60 90 55 108 58" />
    <path d="M95 62 C105 44 125 40 143 44" />
    <path d="M130 48 C140 32 158 30 176 34" />
    <path d="M40 92 C48 76 66 72 82 76" />
  </svg>
);

// Continuous-line wave/knot ornament
export const OrnamentWave = ({ className = '' }) => (
  <svg viewBox="0 0 240 80" className={className} fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round">
    <path d="M6 40 C40 6 60 74 96 40 C132 6 152 74 188 40 C210 18 224 30 234 40" />
  </svg>
);

// Small line-art star separator for the marquee
export const OrnamentStar = ({ className = '' }) => (
  <svg viewBox="0 0 40 40" className={className} fill="none" stroke="currentColor"
    strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6 L23 17 L34 20 L23 23 L20 34 L17 23 L6 20 L17 17 Z" />
  </svg>
);

// Continuous-line heart / hands ornament
export const OrnamentHeart = ({ className = '' }) => (
  <svg viewBox="0 0 120 120" className={className} fill="none" stroke="currentColor"
    strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <path d="M60 100 C20 72 18 44 34 34 C48 25 60 38 60 48 C60 38 72 25 86 34 C102 44 100 72 60 100 Z" />
  </svg>
);
